// extracted by mini-css-extract-plugin
export default {"menuPanel":"MenuPanel_menuPanel__cPXGU"};